import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

const ContentIconType = ({ contentType }) => {
  let iconName;
  switch (contentType) {
    case 'pitchdiagram':
      iconName = 'outline-diagram';
      break;
    case 'session':
      iconName = 'outline-session';
      break;
    case 'folder':
      iconName = 'outline-folder';
      break;
    case 'document':
      iconName = 'outline-description';
      break;
    default:
      iconName = 'outline-ball';
      break;
    // no default
  }

  return <Icon name={iconName} fill={contentType} size="m" />;
};

ContentIconType.propTypes = {
  contentType: PropTypes.string.isRequired,
};

export default ContentIconType;



// WEBPACK FOOTER //
// ./library/app/components/Global/Icons/ContentIconType.js